import { ReactElement } from "react";
import { Popover } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/16/solid";

interface FilterToggleProps {
    label: string;
    count: number | string;
    children: (props: { open: boolean }) => ReactElement;
    panelWidth: number | string;
}

const FilterToggle = (props: FilterToggleProps) => {
    const { label, count, children, panelWidth } = props;

    const hasCount = typeof count === "number" && count > 0;
    const appliedPanelWidth = hasCount ? 'max-w-full' : panelWidth;
    const filterButtonClasses = `filter-btn leading-5 ${appliedPanelWidth} ${hasCount ? "bg-stone-lighter" : ""}`;
    const counterElement = hasCount ? <div className="counter">{count}</div> : null;

    return (
        <Popover className="filter-toggle">
            {({ open }) => (
                <>
                    <Popover.Button className={filterButtonClasses}>
                        {label}
                        {counterElement}
                        <ChevronDownIcon className="w-4 h-4 shrink-0" aria-hidden="true" />
                    </Popover.Button>

                    <Popover.Panel unmount={false} className="absolute right-0 mt-2 filter-popup">
                        {children({ open })}
                    </Popover.Panel>
                </>
            )}
        </Popover>
    );
};

export default FilterToggle;
